module.exports = __webpack_public_path__ + "img/IMAGE9.f926a0e7.jpg";